import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import SimuladoForm from "./components/SimuladoForm";
import BuscaConteudo from "./components/BuscaConteudo";
import Footer from "./components/Footer";
import Popup from "./components/Popup";

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("simulado");

  const closePopup = () => setShowPopup(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 180000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-orange-100">
      <Navbar />
      <Header />

      <div className="container mx-auto mt-6 max-w-lg px-4">
        <div className="flex border-b border-gray-300">
          <button
            onClick={() => setActiveTab("simulado")}
            className={`flex-1 py-2 text-sm font-semibold rounded-tl-lg transition-colors ${
              activeTab === "simulado"
                ? "bg-white text-gray-800 border border-b-white border-gray-300"
                : "bg-orange-100 text-gray-500 hover:text-gray-700"
            }`}
          >
            Simulado por Cargo
          </button>
          <button
            onClick={() => setActiveTab("busca")}
            className={`flex-1 py-2 text-sm font-semibold rounded-tr-lg transition-colors ${
              activeTab === "busca"
                ? "bg-white text-gray-800 border border-b-white border-gray-300"
                : "bg-orange-100 text-gray-500 hover:text-gray-700"
            }`}
          >
            Busca por Conteúdo
          </button>
        </div>
      </div>

      {activeTab === "simulado" ? <SimuladoForm /> : <BuscaConteudo />}

      <Footer />

      {showPopup && (
        <Popup
          message="Concurseira Pobre é e sempre será gratuito! Ao contrário de muitos sites por aí que cobram para acesso a questões. Fique à vontade para usar tudo de graça e, se esse conteúdo te ajudou, considere fazer um PIX de qualquer valor para o programador do site, que também é um concurseiro pobre!"
          onClose={closePopup}
        />
      )}
    </div>
  );
}

export default App;
